import { render, staticRenderFns } from "./VistaRoles.vue?vue&type=template&id=88b9b22e&scoped=true"
import script from "./VistaRoles.vue?vue&type=script&lang=js"
export * from "./VistaRoles.vue?vue&type=script&lang=js"
import style0 from "./VistaRoles.vue?vue&type=style&index=0&id=88b9b22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b9b22e",
  null
  
)

export default component.exports